import React, {useState} from "react";
import {Modal, Button, Header} from 'semantic-ui-react'

//Every page shares the same modal file
function DeleteEntryModal(
    {
        handleClearAssignmentData,
        page,
        assignmentNum
    }
){
    const [open, setOpen] = useState(false);
    return (
        <>
            <Modal
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                open={open}
                trigger={<Button color='black' style={{marginTop: 5, marginLeft: 5}}>Delete Assignment Data</Button>}
            >
                <Modal.Header>Delete {page} for Assignment {assignmentNum}</Modal.Header>
                <Modal.Content image>
                    <Modal.Description>
                        You are about to delete the student submissions for {page}, Assignment {assignmentNum}.<br/>
                        Once this is deleted, you may not be able to access it again.<br/><br/>
                        Are you sure you want to delete this data?<br/>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={()=>setOpen(false)} color='black' floated='right'>No</Button>
                    <Button color='red' onClick={()=>{handleClearAssignmentData(); setOpen(false)}} >Yes, Delete</Button>
                </Modal.Actions>
            </Modal>
        </>
    )
}

export default DeleteEntryModal
